export default {
  data () {
    return {
      componentCreated: false,
      routing: true
    }
  },
  created () {
    if (this.routing) {
      if (this.$route.query.search) {
        this.searchText = this.$route.query.search
        if (this.$route.query.field)
          this.selectedField = this.$route.query.field
      } else {this.searchText = ''}
      if (this.$route.query.order) {
        if (this.$route.query.order.startsWith('-')) {
          this.pagination.descending = true
          this.pagination.sortBy = this.$route.query.order.substr(1)
        } else {
          this.pagination.descending = false
          this.pagination.sortBy = this.$route.query.order
        }
      }
      if (this.$route.query.page) {this.pagination.page = this.$route.query.page}
      if (this.$route.query.count) {this.pagination.rowsPerPage = parseInt(this.$route.query.count)}
      if (this.$route.query.filter) {
        this.filter = JSON.parse(this.$route.query.filter)
        if (this.filter.status !== '') {
          this.searchStatus = this.filter.status
        }
        if (this.filter.template__name) {
          this.formSearch = this.filter.template__name
          this.loadFormTemplates()
          this.filterFormTemplate = `${this.filter.template__name}`
        }
        if (this.filter.case__case_type__id) {
          this.loadCaseTypes(this.filter.case__case_type__id)
          this.filterCaseType = this.filter.case__case_type__id
        }
        if (this.filter.tags__name) {
          this.tagResults = [`${this.filter.tags__name}`]
          this.filterTags = `${this.filter.tags__name}`
        }
        if (this.filter.contact__tags__name) {
          this.tagResults = [`${this.filter.contact__tags__name}`]
          this.filterTags = `${this.filter.contact__tags__name}`
        }
        if (this.filter.hasOwnProperty('read')) {
          this.readFilter = this.filter.read
        }
        if (this.filter.sent_at__gte) {
          this.dateFrom = this.getFormattedDate(this.filter.sent_at__gte)
        }
        if (this.filter.sent_at__lte) {
          this.dateTo = this.getFormattedDate(this.filter.sent_at__lte)
        }
        if (this.filter.bulkop) {
          this.bulkop = this.filter.bulkop
        }
        if (this.filter.active) {
          this.filterClosedCases = this.filter.active
        }
        if (this.filter.hasOwnProperty('is_active')) {
          this.filterEnabled = this.filter.is_active
        }
      }
    }
    this.fetch()
  },
  watch: {
    pagination: function () {
      if (this.componentCreated) {
        var queryParam = {}
        if (this.pagination.sortBy) {queryParam['order'] = (this.pagination.descending ? '-' : '') + this.pagination.sortBy}
        if (this.pagination.page !== 1) {queryParam['page'] = this.pagination.page}
        if (this.pagination.rowsPerPage !== 10) {queryParam['count'] = this.pagination.rowsPerPage}
        if (this.searchText) {
          queryParam['search'] = this.searchText
          if (this.selectedField)
            queryParam['field'] = this.selectedField
        }
        if (this.filter) {
          queryParam['filter'] = JSON.stringify(this.filter)
        }
        if (this.routing) {
          this.$router.push({ query: queryParam })
        } else {
          this.fetch()
        }
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.beforeEnter(to, from, next)
  },
  methods: {
    beforeEnter (to, from, next = null) {
      if (to.query.search) {
        this.searchText = to.query.search
        if (to.query.field)
          this.selectedField = to.query.field
      } else {this.searchText = ''}
      if (to.query.order) {
        if (to.query.order.startsWith('-')) {
          this.pagination.descending = true
          this.pagination.sortBy = to.query.order.substr(1)
        } else {
          this.pagination.descending = false
          this.pagination.sortBy = to.query.order
        }
      } else {
        this.pagination.descending = false
        this.pagination.sortBy = null
      }
      if (to.query.page) {this.pagination.page = to.query.page} else {this.pagination.page = 1}
      if (to.query.count) {this.pagination.rowsPerPage = to.query.count} else {this.pagination.rowsPerPage = 10}
      if (to.query.filter) {
        this.filter = JSON.parse(to.query.filter)
        if (this.filter.status !== '') {
          this.searchStatus = this.filter.status
        }
        if (this.filter.template__name) {
          this.formSearch = this.filter.template__name
          this.loadFormTemplates()
          this.filterFormTemplate = `${this.filter.template__name}`
        }
        if (this.filter.case__case_type__id) {
          this.loadCaseTypes(this.filter.case__case_type__id)
          this.filterCaseType = this.filter.case__case_type__id
        }
        if (this.filter.tags__name) {
          this.tagResults = [`${this.filter.tags__name}`]
          this.filterTags = `${this.filter.tags__name}`
        }
        if (this.filter.contact__tags__name) {
          this.tagResults = [`${this.filter.contact__tags__name}`]
          this.filterTags = `${this.filter.contact__tags__name}`
        }
        if (this.filter.hasOwnProperty('read')) {
          this.readFilter = this.filter.read
        }
        if (this.filter.sent_at__gte) {
          this.dateFrom = this.getFormattedDate(this.filter.sent_at__gte)
        }
        if (this.filter.sent_at__lte) {
          this.dateTo = this.getFormattedDate(this.filter.sent_at__lte)
        }
        if (this.filter.bulkop) {
          this.bulkop = this.filter.bulkop
        }
        if (this.filter.active) {
          this.filterClosedCases = this.filter.active
        }
        if (this.filter.hasOwnProperty('is_active')) {
          this.filterEnabled = this.filter.is_active
        }
      } else {
        this.filter = null
      }
      this.fetch()
      if (next)
        next()
    },
    search () {
      this.pagination.page = 1
      var queryParam = {}
      if (this.searchText) {
        queryParam['search'] = this.searchText
        if (this.selectedField)
          queryParam['field'] = this.selectedField
      }
      if (this.routing) {
        this.$router.push({ query: queryParam })
      } else {
        this.fetch()
      }
    },
    getFormattedDate(value) {
      let date = new Date(value)
      let year = date.getFullYear()
      let month = (1 + date.getMonth()).toString().padStart(2, '0')
      let day = (1 + date.getDate()).toString().padStart(2, '0')
    
      return `${year}-${month}-${day}`
    }
  }
}
